import { PostEntity } from '@interpals/api-web';
import { createSelector } from '@reduxjs/toolkit';

import { ReduxState } from 'redux/root-reducer';

import { FeedScreen } from './reducer';

const selectSelf = (state: ReduxState) => state.posts;

export const selectFeedPosts = createSelector(
    [selectSelf, (_: ReduxState, screen: FeedScreen) => screen],
    (state, screen) => {
        switch (screen) {
            case 'home':
                return state.homeFeed;

            case 'user':
                return state.userFeed;

            case 'group':
                return state.groupFeed;
        }
    },
);

export const selectPostsLastId = createSelector([selectFeedPosts], (posts) => {
    if (posts.length > 0) {
        return posts[posts.length - 1].id;
    }

    return undefined;
});

export const selectPostFromAnyFeed = createSelector([selectSelf, (_: ReduxState, id: string) => id], (state, id) => {
    const { homeFeed, userFeed, groupFeed } = state;

    const post = [...homeFeed, ...userFeed, ...groupFeed].find((p) => p.id === id);

    return post || null;
});

export const selectHomeFeedFilters = createSelector([selectSelf], (state) => state.homeFeedFilters);

export const selectSinglePost = (state: ReduxState): PostEntity | null => state.posts.singlePost;
export const selectIfHasMorePosts = (state: ReduxState): boolean => state.posts.hasMore;
export const selectPinnedPostsRequest = (state: ReduxState) => state.posts.pinnedPosts;
